<template>
	<el-menu
		class="sidebar-el-menu"
		:default-active="onRoutes"
		:collapse="menuType == 1 ? sidebar.collapse : sidebar.collapseMobile"
		:background-color="themeMode == 1 ? '#5E9BE8' : '#222B45' "
		text-color="#BED7F5"
		active-text-color="#ffffff"
		unique-opened
		router
	>
		<!-- 类型 {{ menuType }}--是否折叠{{ sidebar.collapseMobile }} -->
		<template v-for="item in menuList">
			<template v-if="item.subs">
				<el-sub-menu :index="item.index" :key="item.index">
					<template #title>
						<el-icon>
              <component :is="item.icon"></component>
						</el-icon>
						<span>{{ item.title }}</span>
					</template>
					<template v-for="(subItem,key) in item.subs" :key="key">
						<el-menu-item :index="subItem.index" v-setPermission :permissionInfo="subItem.permission">
							<span>{{ subItem.title }}</span>
						</el-menu-item>
					</template>
				</el-sub-menu>
			</template>
			<template v-else>
				<el-menu-item :index="item.index" :key="item.index" v-setPermission :permissionInfo="item.permission">
					<el-icon>
						<component :is="item.icon"></component>
					</el-icon>
					<template #title
						>{{ item.title }}
						<div v-if="item.title == 'Alerts' && alertCounts" class="el-menu-item-tips">{{alertCounts}}</div>
					</template>
				</el-menu-item>
			</template>
		</template>
	</el-menu>
</template>

<script setup>
	import { computed, ref, reactive } from "vue";
	import { useSidebarStore } from "../stores/sidebar";
  	import { useUserInfoStore } from "../stores/userInfoStore";
	const { userInfo } = useUserInfoStore();
	import { useRoute } from "vue-router";
	import menus from "../assets/js/menu";
  	import $http from "@/api";
  	import { sharedState } from '../hooks/sharedState';
	const themeMode = computed(() => sharedState.themeMode);
	const route = useRoute();
	const onRoutes = computed(() => {
		return route.path;
	});
  	const menuList = ref([])
	const sidebar = useSidebarStore();
	const props = defineProps({
		menuType: {
			type: Number,
			required: true,
		},
	});
  	const alertCounts = ref(0);
	const menuType = ref(props.menuType);
	// console.log("menuType",menuType.value)
    // 获取正在预警的数量
  	const getOngoingCount = () => {
		$http.maintenance.getDeviceErrorCurrentCount().then(res => {
		let offlineCount = res.result?.offlineCount || 0;
		let errorCount = res.result?.errorCount || 0;
		alertCounts.value = offlineCount + errorCount;
	})
  };
  const menuListOpt = () =>{
    if(userInfo && ['912262327079018496','971595532671782912'].includes(userInfo.roles[0].id)){
      let optMenu = menus.filter(item => {
        return item.title != 'Users'
      })  
      menuList.value = optMenu
    } else{
      menuList.value = menus
    }
    console.log("menuListOpt",menuList.value)
  }
  menuListOpt()
  getOngoingCount()
</script>

<style lang="scss" scoped>
	// .sidebar {
	// 	display: block;
	// 	position: fixed;
	// 	z-index: 10;
	// 	left: 0;
	// 	top: 70px;
	// 	bottom: 0;

	//   &.is-scroll{
	//     overflow-y: scroll;
	//     scrollbar-width: none; /* Firefox 支持 */
	//     -ms-overflow-style: none;  /* IE/Edge 支持 */
	//   }
	//   /* 隐藏滚动条轨道 (Chrome, Safari, Opera) */
	//   &.is-scroll::-webkit-scrollbar {
	//     display: none;
	//   }
	// 	> p {
	// 		position: absolute;
	// 		bottom: 20px;
	// 		left: 50%;
	// 		transform: translateX(-50%);
	// 		color: #bfcbd9;
	// 	}
	// }

	.sidebar::-webkit-scrollbar {
		width: 0;
	}

	.sidebar-el-menu:not(.el-menu--collapse) {
		width: 225px;
		transition: all 0.4s linear; //菜单收起
    border: none;
	}
	// .sidebar-el-menu{
	//   width: 0px;
	//   &.show{
	//     width: 290px;
	//     transition: all 1s ; //菜单收起

	//   }
	// }

	.sidebar > ul {
		height: 100%;
		width: 200px;
		// transition: all 1s; //菜单收起
	}
	.sidebar-float > ul {
		height: 100%;
	}
	.el-sub-menu .el-icon {
		font-size: 1em;
	}
	.el-menu--collapse {
		width: 0px;
		display: none;
		// transition: all 1s  linear; //菜单收起
	}
	.el-menu-item-tips {
		width: 26px;
    font-size: 12px;
		height: 26px;
		border-radius: 100%;
		background: red;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 20px;
	}
</style>
